// Runtime podešavanja iz /mobile-config.json (isti fajl čita i mobilna) —
// menjaju se izmenom fajla na hostingu, bez novog builda. Fail-open: pad
// mreže/loš JSON vraća podrazumevane vrednosti.

export const DEFAULT_PAST_DEPARTURE_GRACE_MIN = 15;

let cachedGrace = null;

export async function getPastDepartureGraceMinutes() {
    if (cachedGrace !== null) return cachedGrace;
    try {
        const res = await fetch(`/mobile-config.json?t=${Date.now()}`, { cache: "no-store" });
        if (res.ok) {
            const cfg = await res.json();
            const v = cfg?.pastDepartureGraceMinutes;
            cachedGrace = typeof v === "number" && v >= 0 ? v : DEFAULT_PAST_DEPARTURE_GRACE_MIN;
            return cachedGrace;
        }
    } catch {
        // fail-open ispod
    }
    return DEFAULT_PAST_DEPARTURE_GRACE_MIN;
}
